<div
  ngModelGroup="billingAddress"
  class="billingAddress"
  *ngIf="customerDetails"
>
  <div class="top">
    <h1>{{ 'billing_address_title' | i18next }}</h1>
    <nx-ng-checkbox
      #sameAs
      [id]="'checkbox-same-as'"
      [name]="'checkbox-same-as'"
      [labelKey]="'billing_address_same_as'"
      [(ngModel)]="sameAsAccountHolder"
      (change)="handleBillingChanged(sameAsAccountHolder)"
    ></nx-ng-checkbox>
  </div>

  <div class="addressInput" *ngIf="!sameAs.value">
    <div class="input field-large">
      <nx-ng-textfield
        #firstNameField="ngModel"
        *ngIf="!sameAs.value"
        [id]="'firstName'"
        [name]="'firstName'"
        [label]="'customer_details_first_name_label'"
        [errorText]="getFirstNameError(firstNameField)"
        [isRequired]="true"
        [(ngModel)]="customerDetails.firstName"
      >
      </nx-ng-textfield>
    </div>
    <div class="input field-large margin-medium">
      <nx-ng-textfield
        *ngIf="!sameAs.value"
        #lastNameField="ngModel"
        [id]="'lastName'"
        [name]="'lastName'"
        [label]="'customer_details_last_name_label'"
        [errorText]="getLastNameError(lastNameField)"
        [isRequired]="true"
        [(ngModel)]="customerDetails.lastName"
      >
      </nx-ng-textfield>
    </div>
  </div>
  <div *ngIf="sameAs.value" class="addressContent">
    <p class="name">
      {{ customerDetails.firstName }}&nbsp;{{ customerDetails.lastName }}
    </p>
  </div>
  <div class="field-large">
    <nx-ng-address
      [address]="customerDetails.address"
      [readonly]="sameAs.value"
      [mode]="addressMode"
      [addressSearchContext]="addressSearchContext"
      (addressSearch)="handleAddressSearch($event)"
      (addressFound)="handleAddressFound()"
      (postCodeManualChange)="handlePostCodeManualChange($event)"
    >
    </nx-ng-address>

    <nx-ng-validation-success
      *ngIf="postCodeValid"
      [labelKey]="'validation_success_postcode'"
    ></nx-ng-validation-success>

    <div
      *ngIf="postCodeValid === false && childTicketVerifyInProgress === false"
      class="app-error-text"
    >
      <span
        [innerHTML]="
          'validation_failure_postcode'
            | i18next
              : {
                  interpolation: { escapeValue: false },
                  _18andUnderHelpPageLink:
                    ('18_and_under_help_page_link' | i18next: { ns: 'config' })
                }
        "
      ></span>
    </div>
  </div>
</div>
